var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"remo-block",class:{
      'remo-block-lightShadow': _vm.mode === 'light',
      'remo-block-DeepShadow': _vm.mode  === 'deep',
      'remo-block-CurveShadow': _vm.mode === 'curve',
      'remo-block-SharpShadow' : _vm.mode === 'sharp'
  },style:(_vm.mode !== 'sharp' ? _vm.customizeStyle : '')},[_c('div',{staticClass:"content"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e7304044","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./packages/remo-shawdow-block/src/remo-shadow-block.vue
// module id = null
// module chunks = 